import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog } from "../../base/dialog/dialog";
import { DialogShell } from "../dialog-shell/DialogShell";
import { UnsavedChangesConfirmDialog } from "../unsaved-changes-confirm-dialog/unsaved-changes-confirm-dialog";
import { useFormDialogWithUnsavedChanges } from "../../../hooks/useFormDialogWithUnsavedChanges";
/**
 * Composes the `Dialog` + `DialogShell` + `UnsavedChangesConfirmDialog` shell
 * for form dialogs that need the standard "are you sure you want to discard
 * changes?" prompt. Eliminates the boilerplate around
 * `useFormDialogWithUnsavedChanges` so each form dialog can focus on its
 * fields.
 *
 * `InputFormDialog` is NOT migrated to this shell — it uses a `formKey`
 * remount approach instead of `useFormDialogWithUnsavedChanges`.
 */ export function FormDialogShell({ open, onOpenChange, isDirty, isPending = false, size = "lg", shellClassName, children }) {
    const { showCloseConfirmation, handleOpenChange, handleDiscardChanges, handleStay } = useFormDialogWithUnsavedChanges({
        isDirty,
        onClose: ()=>onOpenChange(false)
    });
    const handleOpenChangeUnlessPending = (next)=>{
        if (!next && isPending) return;
        handleOpenChange(next);
    };
    const close = ()=>handleOpenChangeUnlessPending(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Dialog, {
                open: open,
                onOpenChange: handleOpenChangeUnlessPending,
                children: /*#__PURE__*/ _jsx(DialogShell, {
                    size: size,
                    className: shellClassName,
                    children: children({
                        close
                    })
                })
            }),
            /*#__PURE__*/ _jsx(UnsavedChangesConfirmDialog, {
                open: showCloseConfirmation,
                onStay: handleStay,
                onDiscard: handleDiscardChanges
            })
        ]
    });
}

//# sourceMappingURL=FormDialogShell.js.map